import api from './client';
import type { LibraryDocument } from 'types';

export const libraryDocumentsApi = {
  list: async (params?: { org_id?: string; limit?: number }): Promise<LibraryDocument[]> => {
    const { data } = await api.get('/library-documents', { params });
    return data;
  },

  upload: async (file: File, orgId: string): Promise<LibraryDocument> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('org_id', orgId);
    const { data } = await api.post('/library-documents/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  create: async (document: Omit<LibraryDocument, 'id'> & { org_id: string }): Promise<LibraryDocument> => {
    const { data } = await api.post('/library-documents', document);
    return data;
  },

  delete: async (documentId: string): Promise<void> => {
    await api.delete(`/library-documents/${documentId}`);
  },
};
